export default "__VITE_ASSET__DDxEPAW4__"